/**
 * notificationSettingsSlice — Notifications settings (channels + customer/staff
 * delivery matrices).
 *
 * Hydrated from the live notifications API via NotificationSettingsInitializer
 * (seeded server-side by `getNotificationSettingsSSR()`); the form seeds its
 * local state from here and dispatches `setNotificationSettings` with the
 * server-returned value on save.
 */
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import {
  defaultNotificationSettings,
  type NotificationSettings,
} from "@/components/settings/notifications/types";

export interface NotificationSettingsState {
  settings: NotificationSettings;
  loading: boolean;
}

const initialState: NotificationSettingsState = {
  settings: defaultNotificationSettings(),
  loading: true,
};

const notificationSettingsSlice = createSlice({
  name: "notificationSettings",
  initialState,
  reducers: {
    /** Replace the notification settings — used to hydrate on mount and on save. */
    setNotificationSettings(
      state,
      action: PayloadAction<NotificationSettings>,
    ) {
      state.settings = action.payload;
    },
    setNotificationLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
  },
});

export const { setNotificationSettings, setNotificationLoading } =
  notificationSettingsSlice.actions;

export default notificationSettingsSlice.reducer;
